<template>
  <div class="topForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      @input="handleChangeBaseData"
      @goRouter="goRouter"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import dataBaseAPI from '@/api/dataBase';
  // import API from '@/api/financeCenter/generalAccounting';
  import { dateFormat } from '@/filters/index';
  // import qs from 'qs';
  export default {
    components: {
      baseForm,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      canRevert() {
        let flag =
          this.baseData.syncFlag == 'S' &&
          (!this.baseData.entityDataId || this.baseData.entityDataId != -1) &&
          this.baseData.entityCode !== 'AE_AP_ACCRUED' &&
          !this.baseData.reverseFlag;
        // console.log(this.baseData.syncFlag,this.baseData.entityDataId,this.baseData.entityCode,this.baseData.reverseFlag)
        // console.log(flag)
        return flag;
      },
      baseDataOptions() {
        let baseCols = [
          {
            // 公司
            type: 'select',
            label: this.$t('glVoucher.column.voucherCompany'),
            prop: 'voucherCompanyCode',
            options: this.companyList,
            required: true,
            filterable: true,
          },
          {
            // 账套
            type: 'input',
            label: this.$t('glVoucher.column.ledgerCode'),
            prop: 'ledgerName',
            disabled: true,
            placeholder: this.$t('glVoucher.placeholder.auto'),
          },
          {
            // 模块
            type: 'select',
            label: this.$t('glVoucher.column.applicationCode'),
            prop: 'applicationCode',
            options: this.applicationList,
          },
          {
            // 凭证类型
            type: 'select',
            label: this.$t('glVoucher.column.voucherType'),
            prop: 'voucherType',
            options: this.sapVoucherTypeList,
            required: true,
            filterable: true,
          },
          {
            // 币种
            type: 'dict',
            dictType: 'all_currency',
            label: this.$t('glVoucher.column.currencyCode'),
            prop: 'currencyCode',
            required: true,
            filterable: true,
          },
          {
            // 汇率类型、汇率
            type: 'dict',
            label: this.$t('glVoucher.column.exchangeType'),
            prop: 'exchangeType',
            dictType: 'exchange_type',
            required: true,
            filterable: true,
            moreInput: true,
            ruleType: 'object',
            validatorKey: this.baseData.exchangeRate,
            moreProp: 'exchangeRate',
            moreClearable: true,
            moreRequired: true,
            morePlaceholder: this.$t('glVoucher.placeholder.auto'),
            moreDisabled: this.baseData.exchangeType == 'Cooperate',
          },
          {
            // 汇率日期
            type: 'date',
            label: this.$t('glVoucher.column.exchangeDate'),
            prop: 'exchangeDate',
            required: true,
          },
          {
            // 凭证编码
            type: 'input',
            label: this.$t('glVoucher.column.voucherNo'),
            prop: 'voucherNo',
            disabled: true,
            placeholder: this.$t('glVoucher.placeholder.auto'),
          },
          {
            // 参照
            type: 'input',
            label: this.$t('glVoucher.column.referenceNo'),
            prop: 'referenceNo',
            disabled: true,
          },
          {
            // 入账日期
            type: 'date',
            label: this.$t('glVoucher.column.postDate'),
            prop: 'postDate',
            required: true,
            disabled: this.baseData.entityCode == 'AE_AP_ACCRUED',
          },
          {
            // 期间
            type: 'select',
            label: this.$t('glVoucher.column.calendarPeriod'),
            prop: 'calendarPeriod',
            options: this.ledgerPeriodList,
            required: true,
            filterable: true,
          },
          {
            // SAP 凭证编号
            type: 'input',
            label: this.$t('glVoucher.column.sapVoucherNo'),
            prop: 'sapVoucherNo',
            disabled: true,
            // placeholder: this.$t("glVoucher.placeholder.auto"),
            placeholder: '',
          },
          {
            // 入账状态
            type: 'dict',
            dictType: 'VOUCHERSYNFLAG',
            label: this.$t('glVoucher.column.syncFlag'),
            prop: 'syncFlag',
            disabled: true,
            placeholder: this.$t('glVoucher.placeholder.auto'),
          },
          {
            // 创建人
            type: 'input',
            label: '操作人',
            prop: 'createByName',
            placeholder: this.$t('glVoucher.placeholder.auto'),
            disabled: true,
          },
          {
            // 过账人
            type: 'input',
            label: '过账人',
            placeholder: this.$t('glVoucher.placeholder.auto'),
            prop: 'postUserName',
            disabled: true,
          },
          {
            // 凭证日期
            type: 'date',
            label: this.$t('glVoucher.column.voucherDate'),
            prop: 'voucherDate',
            disabled: true,
            required: true,
          },
          {
            // 业务单据编号
            type: 'input',
            label: this.$t('glVoucher.column.entityDataNo'),
            prop: 'entityDataNo',
            disabled: true,
            placeholder: this.$t('glVoucher.placeholder.auto'),
            router: this.baseData.entityUrl,
          },
          {
            // 冲销标识
            type: 'checkbox',
            label: this.$t('glVoucher.column.reverseFlag'),
            prop: 'reverseFlag',
            disabled: true,
            placeholder: this.$t('glVoucher.placeholder.reverseFlag'),
          },
          /*  { // 冲销单据编号
          type: "input",
          label: this.$t("glVoucher.column.reverseDocNo"),
          prop: "reverseDocNo",
          disabled: true,
          placeholder: this.$t("glVoucher.placeholder.reverseDocNo"),
        },
        { // 冲销期间
          type: "input",
          label: this.$t("glVoucher.column.chargeAgainsDateForm"),
          prop: "chargeAgainsDateForm",
          disabled: true,
          placeholder: this.$t("glVoucher.placeholder.chargeAgainsDateForm"),
        }, */
          {
            // 冲销凭证编号
            type: 'input',
            label: this.$t('glVoucher.column.reverseVoucherNo'),
            prop: 'reverseSapVoucherNo',
            disabled: true,
            placeholder: this.$t('glVoucher.placeholder.auto'),
          },
          {
            // 冲销原因
            type: 'dict',
            label: this.$t('glVoucher.column.reverseReason'),
            prop: 'reverseReason',
            dictType: 'reverse_reason',
            disabled: true,
            required: this.baseData.syncFlag == 'S',
            placeholder: this.$t('glVoucher.placeholder.reverseReason'),
          },
          {
            // 冲销日期
            type: 'date',
            label: this.$t('glVoucher.column.reverseDate'),
            prop: 'reverseDate',
            disabled: true,
            required: this.baseData.reverseReason == '04',
            placeholder: this.$t('glVoucher.placeholder.auto'),
          },
          {
            // 备注
            type: 'input',
            label: this.$t('glVoucher.column.summary'),
            prop: 'summary',
            span: 20,
            required: true,
          },
        ];
        let previewVoucherColArr = [
          'voucherCompanyCode',
          'voucherType',
          'postDate',
          'voucherNo',
          'referenceNo',
          'syncFlag',
          'createBy',
          'voucherDate',
          'sapVoucherNo',
          'summary',
          'reverseFlag',
          'reverseDate',
          'reverseVoucherNo',
          'reverseSapVoucherNo',
        ];
        if (this.previewVoucher == 'Y') {
          baseCols = baseCols.filter((item) => previewVoucherColArr.indexOf(item.prop) != -1);
        }
        // 使用字段禁用标识替代表单禁用属性
        if (!this.canEdit) {
          baseCols = baseCols.map((item) => {
            if (!item['disabled']) item['disabled'] = !this.canEdit;
            if (!item['moreDisabled']) item['moreDisabled'] = !this.canEdit;
            return item;
          });
        }
        // 同步成功的  冲销原因 冲销日期可填
        if (this.canRevert) {
          baseCols[baseCols.length - 2].disabled = false;
          baseCols[baseCols.length - 3].disabled = false;
        }
        return baseCols;
      },
    },
    props: ['canEdit', 'previewVoucher'],
    data() {
      return {
        companyList: [], // 公司列表
        applicationList: [], // 模块
        sapVoucherTypeList: [], //凭证类型
        ledgerPeriodList: [], //会计期间
        baseData: {
          id: null,
          originFlag: 'M', //凭证来源 M手动 A自动
          voucherCompanyCode: null, // 公司代码
          voucherCompanyName: null, // 公司名称
          ledgerCode: null, // 账套
          ledgerName: null, // 账套名称
          applicationCode: null, // 模块代码
          applicationName: null, // 模块名称
          voucherType: null, // 凭证类型
          currencyCode: null, // 币种
          companyCurrencyCode: null, // 本币
          exchangeType: null, // 汇率类型
          exchangeRate: null, // 汇率
          exchangeDate: null, // 汇率日期
          docNo: null, // 单据编号
          entityUrl: null, // 业务单据链接
          entityDataNo: null, // 业务单据编号
          postDate: null, // 入账日期
          calendarPeriod: null, // 期间
          voucherNo: null, // 凭证编码
          syncFlag: null, // 入账状态
          createBy: null, // 创建人
          createByName: null, // 创建人名称
          gmtCreate: null, // 创建日期
          sapVoucherNo: null, // SAP 凭证编号
          summary: null, // 备注
          reverseDocNo: null, // '冲销单据号',
          reverseFlag: false, // '冲销标识',
          reverseDate: null, // '冲销日期',
          reverseVoucherNo: null, // '冲销凭证号',
          reverseSapVoucherNo: null, //'冲销SAP凭证编号',
          reverseReason: null, //冲销原因，
          voucherDate: null, //'凭证日期',
          referenceNo: null, // '参照',
          entityDataId: null,
          entityCode: null,
        },
      };
    },
    mounted() {
      if (!this.$route.query.id) {
        this.baseData.createBy = this.userInfo.userCode;
        this.baseData.createByName = this.userInfo.userName;
        this.baseData.exchangeDate =
          this.baseData.postDate =
          this.baseData.voucherDate =
            dateFormat(new Date());
        this.baseData.applicationCode = 'GL';
      }
      this.getDictList();
    },
    methods: {
      goRouter(router) {
        router = JSON.parse(router);
        let path = {
          path: router.path,
          name: router.name,
          meta: {
            keepAlive: true,
            title: router.title,
          },
          query: router.query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleChangeBaseData(val, prop) {
        if (['voucherCompanyCode', 'postDate'].indexOf(prop) != -1) {
          // 根据公司和入账日期筛选期间
          if (prop == 'voucherCompanyCode') {
            // 根据公司获取账套、本币
            this.getLoaclCurrency(val.voucherCompanyCode);
            this.baseData.voucherCompanyName = val.voucherCompanyCode
              ? this.companyList.find((item) => item.value == val.voucherCompanyCode).label
              : null;
          } else {
            this.getFinanceLedgerPeriodList();
          }
        }
        if (prop == 'exchangeType' && val.exchangeType == 'Cooperate') {
          this.getLoaclCurrency(val.voucherCompanyCode);
        }
        if (['currencyCode', 'exchangeDate'].indexOf(prop) != -1) {
          this.getRate();
        }
        if (['exchangeRate', 'summary'].indexOf(prop) != -1) {
          this.$emit('handleChange', this.baseData);
        }
        if (prop == 'applicationCode') {
          this.baseData.applicationName = this.applicationList.find(
            (item) => item.value == this.baseData.applicationCode
          ).label;
        }
      },
      async getFinanceLedgerPeriodList() {
        // 期间
        this.baseData.calendarPeriod = null;
        if (this.baseData.ledgerCode && this.baseData.postDate) {
          let params = {
            ledgerCode: this.baseData.ledgerCode,
            calendarStartDate: this.baseData.postDate,
            calendarEndDate: this.baseData.postDate,
          };
          let res = await this.$axios.post(dataBaseAPI.LIST_FINANCE_LEDGER_PERIOD, params);
          if (res) {
            if (res.data.code == 0) {
              this.ledgerPeriodList = res.data.data.map((item) => {
                return {
                  ...item,
                  label: item.calendarPeriod,
                  value: item.calendarPeriod,
                };
              });
              if (this.ledgerPeriodList.length == 1) {
                this.baseData.calendarPeriod = this.ledgerPeriodList[0].value;
              }
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          }
        } else {
          this.ledgerPeriodList = [];
        }
      },
      getDictList() {
        this.$baseRequest.getCompanyList().then((res) => {
          // 公司
          this.companyList = res;
        });
        this.$baseRequest.getTAeApplication().then((res) => {
          // 模块
          this.applicationList = res.map((item) => {
            return {
              ...item,
              label: item.applicationName,
              value: item.applicationCode,
            };
          });
          if (!this.$route.query.id) {
            this.baseData.applicationName = this.applicationList.find(
              (item) => item.value == this.baseData.applicationCode
            ).label;
          }
        });
        this.$baseRequest.getSapVouScherType().then((res) => {
          // 凭证类型
          this.sapVoucherTypeList = res.map((item) => {
            return {
              ...item,
              label: item.voucherTypeCode,
              value: item.voucherTypeCode,
            };
          });
        });
      },
      async getLoaclCurrency(companyCode) {
        // 获取公司对应本币
        let res = await this.$baseRequest.getLedger(companyCode);
        if (res) {
          if (res.length > 0) {
            this.baseData.ledgerCode = res[0].ledgerCode;
            this.baseData.ledgerName = res[0].ledgerName;
            this.baseData.currencyCode = this.baseData.companyCurrencyCode = res[0].currencyCode;
            this.baseData.exchangeType = res[0].defaultExchangeType;
            this.getRate();
          } else {
            //没有查询到公司账套
            this.$alert(this.$t('glVoucher.message.ledgerInfo'));
            this.baseData.voucherCompanyCode = this.baseData.voucherCompanyName = null; // 清空公司信息
            this.baseData.ledgerCode = this.baseData.ledgerName = null;
            this.baseData.currencyCode = this.baseData.companyCurrencyCode = null;
            this.baseData.exchangeType = this.baseData.exchangeRate = null;
          }
        }
        this.getFinanceLedgerPeriodList();
      },
      async getRate() {
        //获取汇率
        const params = {
          fromCurrencyCode: this.baseData.currencyCode,
          toCurrencyCode: this.baseData.companyCurrencyCode,
          exchangeDate: this.baseData.exchangeDate,
        };
        if (params.fromCurrencyCode && params.toCurrencyCode && params.exchangeDate) {
          if (params.fromCurrencyCode != params.toCurrencyCode) {
            let res = await this.$baseRequest.getRate(params);
            if (res) {
              this.baseData.exchangeRate = res.positiveRate;
            } else {
              this.$message({
                showClose: true,
                message: this.$t('receivablesManage.message.rateInfo'),
                type: 'error',
              });
              this.baseData.currencyCode = this.baseData.exchangeRate = null;
            }
          } else {
            this.baseData.exchangeRate = 1;
          }
        } else {
          this.baseData.exchangeRate = null;
        }
        this.$emit('handleChange', this.baseData);
      },
      exportChildData() {
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          sign = valid ? true : false;
        });
        return sign ? this.baseData : false;
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`glVoucher.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
